/** PUBLIC — feedback on the services report only (separate from employee / dispatch feedback). Route: /service-feedback/:token */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/service-feedback`;

export default function ServiceFeedbackPublic() {
  const { token } = useParams();
  const [v, setV] = useState(null);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [state, setState] = useState("");
  useEffect(() => { axios.get(`${API}/${token}`).then((r) => setV(r.data)).catch((e) => setState(e?.response?.data?.detail || "This link is not valid")); }, [token]);
  const send = () => axios.post(`${API}/${token}`, { rating, comment }).then(() => setState("Thank you for your feedback.")).catch((e) => setState(e?.response?.data?.detail || "Could not save"));
  return (
    <div className="grid min-h-screen place-items-center bg-slate-50 p-6" data-testid="sf-page">
      <div className="w-full max-w-md space-y-3 rounded-2xl border border-slate-200 bg-white p-5">
        <h1 className="text-xl font-bold">How did we do?</h1>
        {v && <p className="text-[13px] text-slate-600">Quote {v.quote_code} · PO {v.po || "not provided"}</p>}
        {state ? <p className="text-[14px]" data-testid="sf-state">{state}</p> : v && <>
          <div className="flex gap-1">{[1, 2, 3, 4, 5].map((n) => <button key={n} onClick={() => setRating(n)} aria-label={`${n} stars`} data-testid={`sf-star-${n}`}><Star className={`h-8 w-8 ${n <= rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} /></button>)}</div>
          <textarea className="w-full rounded-lg border border-slate-300 p-2 text-[14px]" rows={4} maxLength={1000} value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Anything we could do better?" data-testid="sf-comment" />
          <button disabled={!rating} onClick={send} className="w-full rounded-full bg-slate-900 py-2.5 font-bold text-white disabled:bg-slate-300" data-testid="sf-submit">Send feedback</button>
        </>}
      </div>
    </div>
  );
}
